import { motion, type Easing } from 'framer-motion';
import Image from "next/image";
import { BackgroundParticles } from './background-particles';
import { BackgroundSquares } from './background-squares';
import { cn } from '@kit/ui/utils';

const ease: Easing = [0.16, 1, 0.3, 1];

interface HeroBackgroundProps {
  showSquares?: boolean;
  showLights?: boolean;
  glowProps?: React.ComponentProps<typeof motion.div>;
  particlesProps?: React.ComponentProps<typeof BackgroundParticles>;
}

const HeroBackground = ({ showSquares = true, showLights = true, glowProps, particlesProps }: HeroBackgroundProps) => {
  return (
    <>
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.5, duration: 3, ease }}
        {...glowProps}
        className={cn(
          'absolute z-20 top-0 pointer-events-none',
          glowProps?.className
        )}
      >
        <Image
          src="/images/background-glow.png"
          alt="background glow"
          width={2461}
          height={1076}
          className="max-w-none"
        />
      </motion.div>

      {showLights && (
        <motion.div
          initial={{ opacity: 0, y: -500, scale: 0.5 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ delay: 1.5, duration: 1, ease }}
          className="absolute z-0 pointer-events-none top-0 mx-auto origin-top"
        >
          <Image
            src="/images/lights.jpg"
            alt="lights"
            width={1440}
            height={790}
          />
        </motion.div>
      )}

      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.5, duration: 3, ease }}
        className="absolute z-0 top-0 w-full h-[820px] max-w-1440 mx-auto pointer-events-none"
      >
        <BackgroundParticles {...particlesProps} />
      </motion.div>

      {showSquares && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 2, ease }}
          className="absolute z-10 top-0 w-full"
        >
          <BackgroundSquares />
        </motion.div>
      )}
    </>
  );
};

export default HeroBackground;